import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const FILING_BATCH_MOVE_MODAL_HELP: HelpContent[] = [
    {
        helpContentId: 'filing-batch-move-modal.header',
        tooltipText: 'Move filings to a different or a new filing batch.',
        hasIcon: true
    }
];
